module.exports = __webpack_public_path__ + "img/8.cef6086f.jpg";